export default function gateByFeature (name, features = {}, state) {
  if (!features[name]) {
    state.changePage('not_found')
    return true
  }
}
